import { ImportRow } from "src/core/utils/import/types";

export const paginateImportRows = (rows: ImportRow[], pageSize: number, pageIndex: number) => {
  const size = pageSize > 0 ? pageSize : 1;
  const treated = rows
    .filter((row) => row.processedOrder !== null)
    .sort((left, right) => (right.processedOrder ?? 0) - (left.processedOrder ?? 0));
  const untreated = rows
    .filter((row) => row.processedOrder === null)
    .sort((left, right) => left.lineNumber - right.lineNumber);

  const pages: ImportRow[][] = [];

  if (treated.length > 0) {
    const remainder = treated.length % size;
    const currentCount = remainder === 0 ? size : remainder;
    pages.push(treated.slice(0, currentCount));
    for (let index = currentCount; index < treated.length; index += size) {
      pages.push(treated.slice(index, index + size));
    }
  }

  for (let index = 0; index < untreated.length; index += size) {
    pages.push(untreated.slice(index, index + size));
  }

  const totalPages = pages.length;
  const safeIndex = totalPages === 0 ? 0 : Math.min(Math.max(pageIndex, 0), totalPages - 1);

  return {
    pageRows: pages[safeIndex] ?? [],
    totalPages,
    totalCount: rows.length,
  };
};
